module.exports = __webpack_public_path__ + "img/lumi_accessories.6beb8ed8.png";